/**
 * @generated SignedSource<<5ea5366cb484dcdf28c9433e3aac2859>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ParentType = "BLOCK" | "CST" | "PASSAGE" | "SECTION" | "%future added value";
export type ReportSessionType = "DIAGNOSTIC" | "PRACTICETEST" | "STUDYPACK" | "%future added value";
export type SessionItemType = "ACTION" | "BLOCK" | "CHOICE" | "CST" | "PASSAGE" | "QUESTION" | "SECTION" | "%future added value";
export type SessionStatus = "ACTIVE" | "COMPLETE" | "PAUSED" | "%future added value";
export type SessionVariant = "CST" | "MCQ" | "PASSAGE" | "SATA" | "%future added value";
export type FetchSessionQuery$variables = {
  numericId?: number | null;
  sessionId?: string | null;
  userId?: string | null;
};
export type FetchSessionQuery$data = {
  readonly getMixedItemSession: {
    readonly examBreak: any | null;
    readonly examName: string | null;
    readonly id: string;
    readonly numericId: number | null;
    readonly progressList: ReadonlyArray<{
      readonly id: string | null;
      readonly progress: number | null;
    } | null> | null;
    readonly reportSessionType: ReportSessionType | null;
    readonly sessionItems: ReadonlyArray<{
      readonly children: ReadonlyArray<{
        readonly answers: {
          readonly isCorrect: boolean | null;
          readonly pointsList: ReadonlyArray<{
            readonly choiceId: string | null;
            readonly points: number | null;
          } | null> | null;
          readonly score: number | null;
          readonly selectedChoiceIds: ReadonlyArray<string | null> | null;
          readonly timeTaken: number | null;
        } | null;
        readonly children: ReadonlyArray<{
          readonly answers: {
            readonly isCorrect: boolean | null;
            readonly pointsList: ReadonlyArray<{
              readonly choiceId: string | null;
              readonly points: number | null;
            } | null> | null;
            readonly score: number | null;
            readonly selectedChoiceIds: ReadonlyArray<string | null> | null;
            readonly timeTaken: number | null;
          } | null;
          readonly children: ReadonlyArray<{
            readonly answers: {
              readonly isCorrect: boolean | null;
              readonly score: number | null;
              readonly selectedChoiceIds: ReadonlyArray<string | null> | null;
              readonly selectedaction: boolean | null;
              readonly timeTaken: number | null;
            } | null;
            readonly explanation: string | null;
            readonly feedback: string | null;
            readonly id: string;
            readonly isCorrect: boolean | null;
            readonly stem: string | null;
            readonly text: string | null;
          } | null> | null;
          readonly crossOut: ReadonlyArray<string | null> | null;
          readonly displayName: string | null;
          readonly explanation: string | null;
          readonly feedback: string | null;
          readonly highlight: string | null;
          readonly id: string;
          readonly instruction: string | null;
          readonly isCorrect: boolean | null;
          readonly itemType: SessionItemType | null;
          readonly lastUpdated: boolean | null;
          readonly marked: boolean | null;
          readonly maxChoiceCount: number | null;
          readonly minChoiceCount: number | null;
          readonly numFirstSelections: number | null;
          readonly points: number | null;
          readonly stem: string | null;
          readonly text: string | null;
          readonly variant: SessionVariant | null;
          readonly video: string | null;
        } | null> | null;
        readonly crossOut: ReadonlyArray<string | null> | null;
        readonly displayName: string | null;
        readonly explanation: string | null;
        readonly highlight: string | null;
        readonly id: string;
        readonly instruction: string | null;
        readonly isCorrect: boolean | null;
        readonly itemType: SessionItemType | null;
        readonly lastUpdated: boolean | null;
        readonly marked: boolean | null;
        readonly maxChoiceCount: number | null;
        readonly minChoiceCount: number | null;
        readonly numFirstSelections: number | null;
        readonly parentStem: string | null;
        readonly parentType: ParentType | null;
        readonly points: number | null;
        readonly stem: string | null;
        readonly tags: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly text: string | null;
        readonly variant: SessionVariant | null;
        readonly video: string | null;
      }>;
      readonly containerId: string | null;
      readonly crossOut: ReadonlyArray<string | null> | null;
      readonly displayName: string | null;
      readonly highlight: string | null;
      readonly id: string;
      readonly itemType: SessionItemType | null;
      readonly lastUpdated: boolean | null;
      readonly marked: boolean | null;
      readonly maxChoiceCount: number | null;
      readonly minChoiceCount: number | null;
      readonly numItems: number | null;
      readonly sessionConfig: any | null;
      readonly stem: string | null;
      readonly tags: ReadonlyArray<{
        readonly id: string | null;
        readonly label: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly video: string | null;
    }>;
    readonly sessionTime: number | null;
    readonly startTime: any;
    readonly status: SessionStatus | null;
    readonly totalTime: number | null;
  } | null;
};
export type FetchSessionQuery = {
  response: FetchSessionQuery$data;
  variables: FetchSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numericId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stem",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastUpdated",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marked",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highlight",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "crossOut",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxChoiceCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minChoiceCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "video",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "TagDetails",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "variant",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numFirstSelections",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instruction",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCorrect",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "explanation",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedChoiceIds",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeTaken",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Answers",
  "kind": "LinkedField",
  "name": "answers",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PointsList",
      "kind": "LinkedField",
      "name": "pointsList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "choiceId",
          "storageKey": null
        },
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feedback",
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "numericId",
        "variableName": "numericId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "CstSession",
    "kind": "LinkedField",
    "name": "getMixedItemSession",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numericId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "examName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportSessionType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "examBreak",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProgressList",
        "kind": "LinkedField",
        "name": "progressList",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionItem",
        "kind": "LinkedField",
        "name": "sessionItems",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "containerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numItems",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionConfig",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SessionChildItem",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v5/*: any*/),
              (v15/*: any*/),
              (v6/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentStem",
                "storageKey": null
              },
              (v17/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v18/*: any*/),
              (v13/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SessionChildItem",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v19/*: any*/),
                  (v6/*: any*/),
                  (v20/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v18/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v26/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v21/*: any*/),
                  (v17/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SessionChildItem",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v26/*: any*/),
                      (v4/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Answers",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "selectedaction",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FetchSessionQuery",
    "selections": (v27/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FetchSessionQuery",
    "selections": (v27/*: any*/)
  },
  "params": {
    "cacheID": "75b33769d09af0c5663bacc27fe74af3",
    "id": null,
    "metadata": {},
    "name": "FetchSessionQuery",
    "operationKind": "query",
    "text": "query FetchSessionQuery(\n  $userId: ID\n  $sessionId: ID\n  $numericId: Int\n) {\n  getMixedItemSession(userId: $userId, sessionId: $sessionId, numericId: $numericId) {\n    id\n    numericId\n    examName\n    reportSessionType\n    status\n    totalTime\n    sessionTime\n    startTime\n    examBreak\n    progressList {\n      id\n      progress\n    }\n    sessionItems {\n      id\n      containerId\n      numItems\n      stem\n      itemType\n      lastUpdated\n      displayName\n      sessionConfig\n      marked\n      highlight\n      crossOut\n      maxChoiceCount\n      minChoiceCount\n      video\n      tags {\n        id\n        label\n        type\n      }\n      children {\n        id\n        stem\n        displayName\n        itemType\n        variant\n        lastUpdated\n        numFirstSelections\n        parentType\n        parentStem\n        instruction\n        maxChoiceCount\n        minChoiceCount\n        points\n        video\n        marked\n        highlight\n        crossOut\n        tags {\n          id\n          label\n          type\n        }\n        text\n        isCorrect\n        explanation\n        answers {\n          isCorrect\n          selectedChoiceIds\n          timeTaken\n          score\n          pointsList {\n            choiceId\n            points\n          }\n        }\n        children {\n          id\n          stem\n          displayName\n          text\n          lastUpdated\n          isCorrect\n          marked\n          maxChoiceCount\n          minChoiceCount\n          points\n          video\n          highlight\n          crossOut\n          itemType\n          feedback\n          variant\n          numFirstSelections\n          explanation\n          instruction\n          answers {\n            isCorrect\n            selectedChoiceIds\n            timeTaken\n            score\n            pointsList {\n              choiceId\n              points\n            }\n          }\n          children {\n            id\n            text\n            feedback\n            stem\n            isCorrect\n            explanation\n            answers {\n              isCorrect\n              selectedChoiceIds\n              timeTaken\n              score\n              selectedaction\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "182c6979785dc415e19621c1aec6611f";

export default node;
